<template>
  <span>
    <v-list-item
      v-for="field in fields"
      v-bind:key="field.id"
    >
      <v-list-item-content>
        <v-list-item-title>
          <Attribute
            v-if="field.type === 'computed'"
            :item="computedValue(field)||null"
            :translate="field.translate"
            :is-date="field.type === 'date'"
          />
          <Attribute
            v-else
            :item="value[field.name]||null"
            :translate="field.translate"
            :is-date="field.type === 'date'"
          />
        </v-list-item-title>
        <v-list-item-subtitle v-html="getItemSubtitle(field)" />
      </v-list-item-content>
    </v-list-item>
    <v-divider />
  </span>
</template>
<script>
import Attribute from '@/components/dashboard/Attribute';
export default {
  components: {
    Attribute
  },
  props: {
    fields: {
      required: true,
      type: Array
    },
    value: {
      required: true,
      type: Object
    }
  },
  methods: {
    computedValue(field) {
      let sum = 0;
      field.computed_from.forEach(key => {
        sum += this.value[key] || 0;
      });
      if (!sum) {
        return null;
      }
      return sum;
    },
    getItemSubtitle(field) {
      return `${field[`label_${this.$i18n.locale}`]} ${field.measure_unit || ''}`;
    }
  }
};
</script>